module.exports = " <div class=nav-main _v-1a44a0f7=\"\"> <div class=wrap _v-1a44a0f7=\"\"> <a class=nav-home v-link=\"{name: 'index'}\" _v-1a44a0f7=\"\">Wooyun Drops</a> <ul class=nav-github _v-1a44a0f7=\"\"> <li _v-1a44a0f7=\"\"><a href=https://github.com/SuperKieran/WooyunDrops target=_blank _v-1a44a0f7=\"\">GitHub</a></li> </ul> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/vue-html-loader/1.2.3/vue-html-loader!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/template-rewriter.js?id=_v-1a44a0f7!./~/.npminstall/vue-loader/8.5.3/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
 ** module id = 25
 ** module chunks = 2
 **/